'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLASTIC_BAG = 'Plastic bag in fridge';
var UNCOVERED = 'Unconvered in fridge';
var UNWRAPPED = 'Unwrapped at room temperature, cool, airy, place';
var WRAPPED = 'Wrapped in fridge';
var COVER = 'Cover, in fridge';
var UNCOVERED_CRISPER = 'Uncovered in crisper of fridge';

var AIRTIGHT = 'Airtight plastic bag in fridge';
var HUSK = 'Store husk in plastic bag in fridge 1 week';
var CRISPER = 'Crisper of fridge';
var AIRTIGHT_CRISPER = 'Airtight plastic bag in crisper of fridge';
var PAPER = 'Brown paper bag in crisper';
var COOL = 'Cool, dark, dry place';
var WHOLESTORE = 'Whole-store at room temp. Cut-wrapped in plastic in fridge';
var RIPEN = 'Ripen at room temperature, then store in crisper of fridge';

var VEGETABLE = 'Vegetable';
var FRUIT = 'Fruit';

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2Res10 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Res10, _Component);

  function Module2Res10() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Res10);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Res10.__proto__ || (0, _getPrototypeOf2.default)(Module2Res10)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Storing fruit and vegetables',
      fruittable: {
        'Apples': PLASTIC_BAG,
        'Apricots': UNCOVERED,
        'Bananas': UNWRAPPED,
        'Berries': COVER,
        'Cherries': PLASTIC_BAG,
        'Grapes': PLASTIC_BAG,
        'Kiwifruit': UNCOVERED_CRISPER,
        'Lemons & Limes': UNCOVERED,
        'Mandarins': UNCOVERED,
        'Mangoes': WRAPPED,
        'Nectarines': UNCOVERED_CRISPER,
        'Oranges': UNCOVERED,
        'Passionfruit': PLASTIC_BAG,
        'Peaches': UNCOVERED,
        'Pears': UNCOVERED,
        'Pineapple': UNCOVERED,
        'Plums': UNCOVERED,
        'Rockmelon': UNCOVERED,
        'Watermelon': UNCOVERED
      },
      vegetable: {
        'Asparagus': AIRTIGHT + ', 1 week',
        'Beans': AIRTIGHT + ', 1 week',
        'Broccoli': AIRTIGHT + ', 1 week',
        'Carrots': AIRTIGHT + ', 2 weeks',
        'Cauliflower': AIRTIGHT + ', 1 week',
        'Celery': AIRTIGHT + ', 2 weeks',
        'Corn': HUSK,
        'Cucumber': UNCOVERED_CRISPER,
        'Eggplant': CRISPER,
        'Lettuce': AIRTIGHT_CRISPER,
        'Mushrooms': PAPER,
        'Onion': COOL,
        'Peas': AIRTIGHT_CRISPER,
        'Potatoes': COOL,
        'Pumpkin': WHOLESTORE,
        'Spinach or Silverbeet': UNCOVERED_CRISPER,
        'Squash': COOL,
        'Tomatoes': RIPEN,
        'Zucchini': AIRTIGHT
      }
    }, _this.handleClickNext = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage + 1;
      _this.setState(obj);
    }, _this.handleClickPrev = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage - 1;
      _this.setState(obj);
    }, _this.handleOnClick = function (item, event) {
      event.preventDefault();
      console.log(event);
      console.log('CLICKED ' + item);
      var obj = _this.state;
      obj.currPage = item;
      _this.setState(obj);
    }, _this.renderTable = function (type) {
      var obj = {};
      if (type === FRUIT) {
        obj = _this.state.fruittable;
      } else if (type === VEGETABLE) {
        obj = _this.state.vegetable;
      }

      var renderHTML = '<table class="table table-bordered table-striped"><thead><tr><th>' + type + '</th><th>Storage</th></tr></thead><tbody>';
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          renderHTML += '<tr><td>' + key + '</td><td>' + obj[key] + '</td></tr>';
        }
      }
      renderHTML += '</tbody></table>';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: renderHTML } })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   *  User clicks on Next
   *  Increments the Page number and changes panel
   */


  /**
   *  User clicks on Previous
   *  Decrements the Page number and changes panel
   */


  /*
   * Quick link at the top to change the current page
   * to the selected page
   */


  /*
   * Render the storage table
   */


  (0, _createClass3.default)(Module2Res10, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, xs: 12, sm: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 2'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 6 },
                this.renderTable(FRUIT)
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 6 },
                this.renderTable(VEGETABLE)
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module2Res10;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module2Res10;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/2/Res10.js
// module id = 1237
// module chunks = 0